import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import Typography from '@mui/material/Typography';

export default function NotiAlertComfirmManageDel({
  open,
  setOpen,
  handleDeleteUser,
  setId,
  t,
}) {
  const handleClose = () => {
    setOpen(false);
    setId('');
  };

  return (
    <div>
      <Dialog
        onClose={handleClose}
        fullWidth
        maxWidth="xs"
        aria-labelledby="customized-dialog-title"
        open={open}
        sx={{
          '& .MuiDialog-paper': {
            borderRadius: '15px',
          },
        }}
      >
        <DialogActions sx={{ backgroundColor: '#D9D9D9' }}>
          <IconButton aria-label="close" onClick={handleClose}>
            <CancelOutlinedIcon />
          </IconButton>
        </DialogActions>
        <DialogContent dividers>
          <Typography
            variant="h6"
            gutterBottom
            sx={{
              color: 'primary.light',
              display: 'flex',
              justifyContent: 'center',
              mt: '10px',
            }}
          >
           {t('app.confirmDelete')}
          </Typography>
          {/* <Typography
            sx={{ display: 'flex', justifyContent: 'center', color: '#757575' }}
          >
            Transaction Ref No.
            <div className=" text-yellow-500 ml-2">
              {' '}
              {dataRowDetail?.order_id_ref}{' '}
            </div>
          </Typography> */}
          <DialogActions
            sx={{
              display: 'flex',
              justifyContent: 'center',
              marginTop: '15px',
            }}
          >
            <Button
              variant="contained"
              autoFocus
              onClick={handleDeleteUser}
              sx={{ color: '#fff', borderRadius: 15 }}
            >
              {t('app.yes')}
            </Button>
            <Button
              variant="contained"
              autoFocus
              onClick={handleClose}
              sx={{ color: '#fff', borderRadius: 15, backgroundColor: 'grey' }}
            >
              {t('app.cancel')}
            </Button>
          </DialogActions>
        </DialogContent>
      </Dialog>
    </div>
  );
}
